import { BASE_URL } from "./config/api_collection";

export interface EnvType {
  graphqlServer: string;
}

const GRAPHQL_API = `${BASE_URL}/api/v2/graph/graphql`;

export default function getEvnData(env: string): EnvType {
  switch (env) {
    case "local":
      return {
        graphqlServer: GRAPHQL_API
      };
    case "prod":
      return {
        graphqlServer: GRAPHQL_API
      };
  }
}
